import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "text" };
import { computed, getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        rfid: { default: '' },
        size: { default: 0.75 }
    },
    setup(__props) {
        const props = __props;
        const { proxy } = getCurrentInstance();
        const store = proxy === null || proxy === void 0 ? void 0 : proxy.$store;
        const specialRfids = computed(() => {
            return store.direct.state.rfid.specialRFID;
        });
        function teamBadge() {
            var _a, _b;
            return (_b = (_a = specialRfids.value[props.rfid]) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
        }
        function getTeamBadgeStyle() {
            var _a, _b, _c;
            if ((_a = specialRfids.value[props.rfid]) === null || _a === void 0 ? void 0 : _a.color) {
                const color = (_c = (_b = specialRfids.value[props.rfid]) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : '#198754';
                return 'background-color: ' + color + ';' +
                    'color: ' + getContrastColor(color) + ';';
            }
            return 'background-color: rgb(25, 135, 84);';
        }
        function getContrastColor(hex) {
            // eslint-disable-next-line no-param-reassign
            hex = hex.replace(/^#/, '');
            // Parse hex to RGB
            const r = Number.parseInt(hex.slice(0, 2), 16);
            const g = Number.parseInt(hex.slice(2, 4), 16);
            const b = Number.parseInt(hex.slice(4, 6), 16);
            // YIQ formula for brightness
            const yiq = (r * 299 + g * 587 + b * 114) / 1000;
            // Return black for light bg, white for dark bg
            return yiq >= 128 ? '#000000' : '#FFFFFF';
        }
        return (_ctx, _cache) => {
            return (teamBadge())
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "badge rounded-pill",
                    style: _normalizeStyle(getTeamBadgeStyle() + 'font-size:' + __props.size + 'em;')
                }, [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(teamBadge()), 1)
                ], 4))
                : _createCommentVNode("", true);
        };
    }
});
